$shm_ba_profile_switch $mol_view
	sub /
		<= Current $mol_pop_over
			Anchor <= Login $mol_button_minor
				title <= login \
			bubble_content /
				<= Exit $mol_button_minor
					title \Выйти
					click? <=> exit? null
